import React from 'react';
import {Toolbar} from 'react-admin';
import { EMPTY_WEEK, SALON, USER } from '../../consts/Names';
import {SaveWithUpdateButton} from '../utils/RecordWrappers';

const reworkedData = (props) => {
   let work_time = props[SALON.work_time]
   if(work_time === EMPTY_WEEK)
      work_time = [];
   if(!props[SALON.name])  
      props[SALON.name] = "";
   if(!props[SALON.address])
      props[SALON.address] = "";
   if(!props[SALON.latitude])
      props[SALON.latitude] = "";
   if(!props[SALON.longitude])
      props[SALON.longitude] = "";
    return Object.assign({}, props, {id: props.salon_id, work_time:work_time});
};
    
export const SalonEditToolbar = (props) => (
   <Toolbar {...props} className={props.className}>
      <SaveWithUpdateButton replaceFunction={reworkedData} updatedSource={SALON.SOURCE} redirect={`/${USER.SOURCE}/${props.record.id}/show/2`} submitOnEnter={false} variant="text" />      
   </Toolbar>
);

